export enum QueryParams {
  SEARCH_KEY_WORDS = "searchKeywords",
  LANGUAGES = "languages",
  SPECIALITY_IDS = "specialityIds",
  AREAS_OF_INTEREST = "areasOfInterest",
  LONGITUDE = "longitude",
  LATITUDE = "latitude",
  LOCATION = "location",
  IDS = "ids",
}
